var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
ImageBlur = require('../../src/js/lib/image-blur.js');
/**
 * Initializes the hero module.
 * @constructor
 * @param {Object} el - The hero element.
 */ 
function EventHero(el) {
  this.el = el;
	this.$el = $(el);
	
	// add lazyload somewhere .lazyLoad()?

	this.$image = this.$el.find('.event-hero__bg-wrapper');
  this.$background = this.$el.find('.event-hero__bg-blur');

  var url = this.$image.attr('data-blur-bg');

  if(url) {
		new ImageBlur({
			el: this.$background[0],
			path: url,
			radius: 50
		});
	}

	this.$background.velocity("transition.fadeIn",{ duration: 1000 });

	$video = this.$el.find('video');

	//video loading dot animation
	$video.on('canplay', function() {
    if(!Modernizr.touchevents) {
      $('.video-loader').velocity('fadeOut', {
        duration: 600,
        easing: [.72, 0, .28, 1]
      });
    } 
    else {
      $('.video-loader').addClass('hidden');
    }
  });

	//Video fallback
	/*var $fallback = this.$el.find('.event-hero__fallback');
	$video.on('error', function() {
 	   $video.hide();
	   $fallback.addClass('js-fallback-active');
	});

	if ( !Modernizr.video || !($video.length) ){
   	$fallback.addClass('js-fallback-active');
  }*/

	var $els = $('[data-fade-in]',this.$el);
  $els.velocity("transition.fadeIn",{ duration: 1000 });

}

module.exports = EventHero;
